// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"132":"68ed21fc","138":"9fa2eec6","200":"7a9ed059","297":"993df870","329":"7d2714e7","363":"d0f07759"}[chunkId] + ".chunk.css";
};